"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'shopDetail',
  components: {},
  data: function data() {
    return {
      showAllDevices: true,
      showPercent: _index.showPercent,
      info: {
        store_info: {},
        bao_fee_plan: {},
        profit_info: {}
      },
      selSnArr: [],
      selType: {},
      // 商户收益数据
      isSyqkObj: {},
      // 商户收益数据状态
      isSyqkObjStatus: 0
    };
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    }
  },
  mounted: function mounted(options) {
    this.getInfo();
    this.getProfitData();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/sttuf/my_merchant_detail_new', {
        store_id: this.$route.params.id
      }).then(function (res) {
        _this.info = res;
        _this.getDeviceType(res.son_id);
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 获取商户的收益数据
     */
    getProfitData: function getProfitData() {
      var _this2 = this;
      this.$get('agentapi/admin/getSyqk', {
        id: this.$route.params.id
      }).then(function (res) {
        if (!res) {
          _this2.isSyqkObjStatus = 1;
        } else {
          _this2.isSyqkObjStatus = 10;
          _this2.isSyqkObj = res;
        }
      }).catch(function () {
        _this2.listLoading = -1;
      });
    },
    /**
     * 切换设备表格显示状态
     */
    toggleDeviceTable: function toggleDeviceTable() {
      this.showAllDevices = !this.showAllDevices;
    },
    /**
     * 获取设备类型
     */
    getDeviceType: function getDeviceType(id) {
      var _this3 = this;
      this.$get('agentapi/sttuf/son_device_type', {
        son_id: id
      }).then(function (res) {
        var selType = {};
        for (var i in res) {
          if (res[i].son_taked > 0) {
            selType[res[i].depend_type] = true;
          }
        }
        _this3.selType = selType;
      });
    },
    /**
       * 选择设备
       * @param {Object} res
       */
    selSb: function selSb(list) {
      var selSnArr = [],
        selID = [];
      for (var i in list) {
        selSnArr.push(list[i].goods_sn);
        selID.push(list[i].id);
      }
      this.selSnArr = selSnArr;
      this.selID = selID;
    },
    /**
    * 解绑设备
    * @param {Object}
    */
    deleteEquip: function deleteEquip(row) {
      var _this4 = this;
      var that = this;
      this.$alert('确定解绑此商户的设备吗？', '解绑设备', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == "confirm") {
            _this4.$post('agentapi/unset_binded_zuo', {
              zuo_sn: row ? row.goods_sn : _this4.selSnArr
            }).then(function (res) {
              _this4.$message({
                message: '解绑成功',
                type: 'success'
              });
              _this4.getInfo();
            });
          }
        }
      });
    },
    /**
     * 跳转至创建客服跟进记录
     */
    handleCreateCustomerRecord: function handleCreateCustomerRecord(row) {
      this.$router.push({
        path: '/run/customerRecord',
        query: {
          page_call_type: 'create',
          store_id: this.info.store_id,
          store_name: this.info.store_info.name,
          name: this.info.nick_name,
          phone: this.info.profit_info.phone,
          aid: this.info.son_id,
          goods_type: '0'
        }
      });
    },
    /**
     * 跳转至客服跟进记录详情
     */
    handleViewCustomerDetail: function handleViewCustomerDetail(row) {
      this.$router.push({
        path: '/run/customerRecord',
        query: {
          page_call_type: 'query',
          store_id: this.info.store_id
        }
      });
    }
  }
};